import React, { useState, useEffect } from 'react';
import { useTheme } from './ThemeContext';
import './Header.css';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const { isDarkMode, toggleTheme } = useTheme();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header className={`header ${isScrolled ? 'scrolled' : ''}`}>
      <div className="header-container">
        <div className="logo">
          <a href="https://muqueetmc.com" className="logo-link">
            Muqueet Mohsen Chowdhury
          </a>
        </div>
        <button
          className="menu-button"
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          aria-label="Toggle menu"
        >
          <span className="menu-icon">☰</span>
        </button>
        <nav className={`nav ${isMobileMenuOpen ? 'open' : ''}`}>
          <a
            href="https://github.com/mmc03-ucb?tab=repositories"
            target="_blank"
            rel="noopener noreferrer"
            className="nav-link"
            onClick={() => setIsMobileMenuOpen(false)}
          >
            GitHub
          </a>
          <a
            href="https://www.linkedin.com/in/muqueet-mohsen-chowdhury-6a83a9242"
            target="_blank"
            rel="noopener noreferrer"
            className="nav-link"
            onClick={() => setIsMobileMenuOpen(false)}
          >
            LinkedIn
          </a>
          <a
            href="https://devpost.com/mmc324?ref_content=user-portfolio&ref_feature=portfolio&ref_medium=global-nav"
            target="_blank"
            rel="noopener noreferrer"
            className="nav-link"
            onClick={() => setIsMobileMenuOpen(false)}
          >
            Devpost
          </a>
          <button
            className="theme-toggle"
            onClick={toggleTheme}
            aria-label="Toggle theme"
          >
            {isDarkMode ? '☀️' : '🌙'}
            <span className="theme-label">{isDarkMode ? 'Light' : 'Dark'}</span>
          </button>
        </nav>
      </div>
    </header>
  );
};

export default Header;

